package com.fireavert.yardi.common_data.data_models.requests.client_requests

import kotlinx.serialization.Serializable

@Serializable
data class YardiClientImportUnitData(
    val propertyId: Int,
    val yardiCredentialId: Int,
    val yardiPropertyId: String,
    val yardiToConnectUnitMap: Map<String, String>? = null
)
